import React, { useState } from "react";
import Image from "next/image";
import CustomIcon from "components/CustomIcon";
import { Input } from "components/ResumeForm/Form/InputGroup";

interface TextInputSectionProps {
  value: string | undefined;
  placeholder: string;
  fieldName: string;
  missingText: string;
  handleChange: (...args: any[]) => void;
  icon?: string;
}

export const TextInputSection: React.FC<TextInputSectionProps> = ({
  value,
  placeholder,
  fieldName,
  missingText,
  handleChange,
  icon = "duration",
}) => {
  const [isEditing, setIsEditing] = useState(false);
  const [hasAdded, setHasAdded] = useState(false);
  const [isAddOpen, setIsAddOpen] = useState(false);
  
  return (
    <div className="flex items-center rounded-xl px-[6px] sm:px-[9px] py-[8px] sm:py-[10px] xl:p-[15px]"
      style={{ backgroundColor: isEditing || hasAdded ? "white" : "#F8F8F8" ,
         border: isEditing || hasAdded ? "3px solid #F8F8F8" : "3px solid #FFFFFF",
      }}
    >
      <div className="flex w-full items-center justify-start gap-[10px] sm:gap-[15px] lg:gap-[30px]">
        <div className="size-[16px] sm:size-[20px] lg:size-[20px] xl:size-[20px] py-[3px] sm:py-[5px] px-[3px] sm:px-[5px] bg-[#EDAD53] rounded-full">
          <Image
            src={`/icons/${icon}.svg`}
            width={15}
            height={15}
            alt="icon"
            className="w-2 h-2 xl:w-4 xl:h-4"
          />
        </div>
        <span className="text-[10px] xs:text-xs sm:text-sm md:text-base lg:text-[10px]  xl:text-[16px] font-montserrat text-black font-medium">
              {missingText}
        </span>

        {/* Desktop: Show title and inputs separately */}
        {/* <div className="hidden lg:flex w-full items-center justify-start">
          {!hasAdded ? (
            <span className="text-[10px] xs:text-xs sm:text-sm md:text-base lg:text-[10px]  xl:text-[16px] font-montserrat text-black font-medium">
              {isEditing ? `Edit ${fieldName}` : missingText}
            </span>
          ) : (
            <div className="flex w-full items-center">
              <Input
                label=""
                labelClassName="col-span-3"
                name={fieldName}
                placeholder={placeholder}
                value={value}
                onChange={handleChange}
                disabled
              />
            </div>
          )}
        </div> */}

        {/* Mobile: Show title OR inputs (inputs replace title when editing) */}
        {/* <div className="flex lg:hidden w-full items-center justify-start">
          {!isEditing && !hasAdded ? (
            <span className="text-[12px] font-montserrat text-black font-medium">
              {missingText}
            </span>
          ) : !isEditing && hasAdded ? (
            <div className="flex w-full items-center justify-center gap-1">
              <Input
                label=""
                labelClassName="col-span-3"
                name={fieldName}
                placeholder={placeholder}
                value={value}
                onChange={handleChange}
                disabled
              />
            </div>
          ) : (
            <div className="flex w-full items-center justify-center gap-1">
              <Input
                label=""
                labelClassName="col-span-3"
                name={fieldName}
                placeholder={placeholder}
                value={value}
                onChange={handleChange}
              />
            </div>
          )}
        </div> */}
      </div>

      {/* Desktop editing inputs (when isAddOpen) */}
      {/* {isAddOpen && (
        <div style={{ visibility: hasAdded ? "hidden" : "visible" }}
          className="hidden lg:flex w-full items-center justify-center gap-3">
          <Input
            label=""
            labelClassName="col-span-3"
            name={fieldName}
            placeholder={placeholder}
            value={value}
            onChange={handleChange}
          />
        </div>
      )} */}

      {/* Edit button */}
      {/* <button
        onClick={() => {
          setIsEditing(true);
          setHasAdded(false);
        }}
        className="rounded-full xl:p-1 bg-white border shadow-md"
        style={{ visibility: hasAdded ? "visible" : "hidden" }}
      >
        <CustomIcon iconName="edit" />
      </button> */}

      {/* Add/Added button */}
      {/* <button
        onClick={() => {
          setIsAddOpen(true);
          setIsEditing(true);
          if (isAddOpen) {
            setHasAdded(true);
          }
        }}
        className={`rounded-lg flex items-center gap-1 ml-1 sm:ml-2 lg:ml-1
          text-[10px] sm:text-[12px] lg:text-[10px] xl:text-[16px] shadow-xl transition-all duration-200 
          font-poppins font-medium text-[#458ef7] hover:bg-gray-100
          py-1 sm:py-1.5 lg:py-1.5
          ${hasAdded 
            ? 'px-2 sm:px-2.5 lg:px-2 xl:px-3 bg-transparent' 
            : 'px-3 sm:px-6 lg:px-3 xl:px-9 bg-white'
          }`}
        disabled={hasAdded && !isEditing}
      >
        {hasAdded ? "Added" : "Add"}
        {hasAdded && (
          <CustomIcon iconName="greenTick" className="w-3 h-3 sm:w-4 sm:h-4" />
        )}
      </button> */}
    </div>
  );
};